import { Model as t } from "../../../../model.js";
class i extends t {
  constructor(s) {
    super(), this.texts = s.texts, this.design = s.design;
  }
}
export {
  i as KioskConfigurationDisabledModel
};
//# sourceMappingURL=kioskConfigurationDisabled.model.js.map
